import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SID_KEY = "mv_session_id";
const LANDED_KEY = "mv_session_landed";

function getSessionId() {
  let sid = sessionStorage.getItem(SID_KEY);
  if (!sid) {
    sid = (crypto.randomUUID && crypto.randomUUID()) || `s-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    sessionStorage.setItem(SID_KEY, sid);
  }
  return sid;
}

/** Invisible visitor tracker — fires a page-view beacon on each route change. */
export function VisitorTracker() {
  const location = useLocation();
  const lastPath = useRef(null);

  useEffect(() => {
    const path = location.pathname;
    if (lastPath.current === path) return;
    lastPath.current = path;
    const sid = getSessionId();
    const isLanding = !sessionStorage.getItem(LANDED_KEY);
    if (isLanding) sessionStorage.setItem(LANDED_KEY, "1");
    axios
      .post(`${API}/track`, {
        session_id: sid,
        path,
        referrer: document.referrer || "",
        is_landing: isLanding,
      })
      .catch(() => {});
  }, [location.pathname]);

  return null;
}
